import React from 'react'

import {PopoverMenuItemType} from "./const"
import PopoverMenuHeader from "./popover-menu-header"
import PopoverMenuOption from "./menu-option"
import PopoverMenuSeparator from "./popover-menu-separator"

type Props = {
    className?  : string

    options     : Option[]

    hidePopover : callback

    children?   : any       // used when we want build menu with custom html
}

export default function PopoverMenu(props: Props) {
    return (
        <div className={Classes("ui5-popover-menu", props.className)}>
            {_.map(props.options, (option, key)=>{

                switch (option.type) {
                    case PopoverMenuItemType.SEPARATOR  :
                        return <PopoverMenuSeparator key={key}/>

                    case PopoverMenuItemType.HEADER     :
                        return <PopoverMenuHeader key   = {key}
                                                  title = {option.title || option.label}/>


                    case PopoverMenuItemType.COMPONENT:
                        return <option.component key={key} />

                    default:

                        return <PopoverMenuOption key           = {key}
                                                  option        = {option}
                                                  hidePopover   = {props.hidePopover}/>
                }
            })}
        </div>
    )
}
